export default "__VITE_ASSET__Cnle_Zaj__"